import './styles/block-white-text.scss'

interface Props {
    text: string
}

export default function BlockWhiteText({text}: Props) {
    return (
        <div className={'block-white-text'}>
            <h3 className={'block-white-text__title'}>{ text }</h3>
        </div>
    )
}